import { localizedNameObject } from '@innowise-group/utilities';
import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '../store';
import { localizeRequest, mapRequestResponseToRequestItem } from './requests.mappers';
import { LocalizedRequestItemResponse, LocalizedRequestItemsState, RequestItem } from './requests.types';

export const getRequestsState = (state: RootState) => state.requests;

export const getRequestsLoggerData = createSelector(getRequestsState, (state) => {
  const items = state.logger.ids.reduce((acc, val) => {
    acc = {
      ...acc,
      [val]: {
        ...state.logger.items[val],
        candidate: { ...state.logger.items[val].candidate, ...localizedNameObject(state.logger.items[val].candidate) },
        createdBy: { ...state.logger.items[val].createdBy, ...localizedNameObject(state.logger.items[val].createdBy) },
        innerItems: state.logger.items[val].innerItems.map((curr) => {
          return { ...curr, createdBy: { ...curr.createdBy, ...localizedNameObject(curr.createdBy) } };
        }),
      },
    };
    return acc;
  }, {});
  return { ...state.logger, items };
});

export const getRequestsItemsState = createSelector(getRequestsState, (state): LocalizedRequestItemsState => {
  const items = state.requests.ids.reduce<LocalizedRequestItemsState['items']>((accum, curr) => {
    if (state.requests.items[curr]) {
      accum[curr] = localizeRequest(state.requests.items[curr]);
    }
    return accum;
  }, {});
  const currentRequest = state.requests.currentRequest ? localizeRequest(state.requests.currentRequest) : null;

  return { ...state.requests, items, currentRequest };
});

export const getCurrentRequestById = createSelector(
  getRequestsItemsState,
  (state): LocalizedRequestItemResponse | null => state.currentRequest,
);

export const getDefaultRequestById = createSelector(getCurrentRequestById, (request): RequestItem | null =>
  request ? mapRequestResponseToRequestItem(request) : null,
);
